import { Link } from 'react-router-dom';
import { getLatestUpdateComics } from '@/mocks/comics';

export default function LatestUpdates() {
  const updates = getLatestUpdateComics();

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between mb-12 gap-4">
          <div>
            <h2 className="text-3xl md:text-4xl font-bold text-foreground-50">
              最新更新
            </h2>
          </div>
          <p className="text-sm text-foreground-400 max-w-md">
            每日更新热门韩漫最新章节，第一时间追更你喜欢的作品，不错过任何精彩内容。
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {updates.slice(0, 3).map((item, index) => (
            <Link
              key={item.comic.id + item.newChapter}
              to={`/comic/${item.comic.slug}`}
              className="group relative rounded-2xl overflow-hidden border border-background-200/30 transition-all duration-300 hover:border-primary-500/20"
            >
              <div className={`${index === 0 ? 'sm:col-span-1' : ''}`}>
                <div className="flex gap-4 p-4">
                  <div className="w-20 h-28 md:w-24 md:h-32 rounded-xl overflow-hidden flex-shrink-0 border border-background-200/30">
                    <img
                      src={item.comic.coverImage}
                      alt={`${item.comic.title} 最新更新`}
                      title={`${item.comic.title} - ${item.newChapter}`}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="flex-1 min-w-0 flex flex-col justify-between">
                    <div>
                      <div className="flex items-center gap-2 mb-1">
                        {item.isNew && (
                          <span className="text-[10px] font-bold bg-primary-500 text-background-950 px-2 py-0.5 rounded-full whitespace-nowrap">
                            <i className="ri-fire-line text-[10px]"></i>
                            NEW
                          </span>
                        )}
                        <span className="text-xs text-foreground-400">{item.comic.category}</span>
                      </div>
                      <p className="text-foreground-50 font-semibold text-sm">{item.comic.title}</p>
                      <p className="text-xs text-primary-400 mt-1">{item.newChapter}</p>
                    </div>
                    <div className="flex items-center justify-between">
                      <span className="text-[11px] text-foreground-500">
                        {item.comic.author}
                      </span>
                      <span className="text-[11px] text-foreground-600">{item.updatedAt}</span>
                    </div>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 mt-6">
          {updates.slice(3, 6).map((item) => (
            <Link
              key={item.comic.id + item.newChapter}
              to={`/comic/${item.comic.slug}`}
              className="group relative rounded-2xl overflow-hidden border border-background-200/30 bg-background-50/50 transition-all duration-300 hover:border-primary-500/20"
            >
              <div className="flex gap-4 p-4">
                <div className="w-20 h-28 md:w-24 md:h-32 rounded-xl overflow-hidden flex-shrink-0 border border-background-200/30">
                  <img
                    src={item.comic.coverImage}
                    alt={`${item.comic.title} 最新更新`}
                    title={`${item.comic.title} - ${item.newChapter}`}
                    className="w-full h-full object-cover object-top"
                  />
                </div>
                <div className="flex-1 min-w-0 flex flex-col justify-between">
                  <div>
                    <div className="flex items-center gap-2 mb-1">
                      {item.isNew && (
                        <span className="text-[10px] font-bold bg-primary-500 text-background-950 px-2 py-0.5 rounded-full whitespace-nowrap">
                          <i className="ri-fire-line text-[10px]"></i>
                          NEW
                        </span>
                      )}
                    </div>
                    <p className="text-foreground-50 font-semibold text-sm">{item.comic.title}</p>
                    <p className="text-xs text-primary-400 mt-1">{item.newChapter}</p>
                  </div>
                  <div className="flex items-center justify-between">
                    <span className="text-[11px] text-foreground-500">{item.comic.author}</span>
                    <span className="text-[11px] text-foreground-600">{item.updatedAt}</span>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}